import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader } from "@googlemaps/js-api-loader";
import decoder from "decode-google-map-polyline";
import ReactDatePicker from "react-datepicker";
import Cookies from "js-cookie";

import zervxpng from "../../assets/images/zervxpng.png";
// import zervxpng from "../../../assets/images/zervxpng.png";
import right from "../../assets/images/bg_city.jpg";
import urls from "../../utils/urls.utils";
import currentLocationIcon from "../../assets/images/current_location.png";
import greenDotIcon from "../../assets/images/green-dot.png";
import redDotIcon from "../../assets/images/red-dot.png";
import GooglePlaceComplete from "../common/GooglePlaceComplete";
import useSettings from "../hooks/useSettings";
import useLanguage from "../hooks/useLanguage";

import { DropdownNormal } from "../common/DropDownNormal";
import CalenderDatePicker from "../common/CalenderDatePicker";
import { FieldWrapper } from "../common/FieldWrapper";
import NavLinks, { LOG_IN } from "../../utils/navLinks";
import zervx_Bgimg from "../../assets/images/bg_city.jpg";
import AvalableDrivers from "./AvalableDrivers";
import useAdmin from "../hooks/useAdmin";
import A from "../../utils/urls.utils";
import { CONST_MILES_VALUE } from "../../utils/constantUtils";
import U from "../../utils/utils";
import RideBooking from "./RideBooking";
import { PopUp } from "../common/PopUp";
import { FiMenu, FiCast } from "react-icons/fi";
import { FaCar, FaReceipt, FaSpinner, FaUser } from "react-icons/fa";
import { CgArrowLongRightL, CgLogIn } from "react-icons/cg";

import Login from "./Login";
import { RideDeatilscontext } from "../context/RideDeatils";
import { CardDeatilscontext } from "../context/CardDeatilsContext";
import Notification from "./Notification/index";
import useSocket from "../hooks/useSocket";
// import Notification from "./Notification/index";
import appImg from "../../assets/images/appStore.svg";
import playImg from "../../assets/images/playStore.webp";
import { MdCopyright } from "react-icons/md";
import ongoingRideImg from "../../assets/images/service_ride_icon.png";
import NavBar from "../navBar/NavBar";
import { Button, Modal } from "react-bootstrap";
import { SmallLoader } from "../common/SmallLoader";
import { Shimmer } from "react-shimmer";
import { format } from "date-fns";
//
function HomePage() {
  const { language } = useLanguage();
  const { rideDeatilsData, setRideDeatilsData } =
    useContext(RideDeatilscontext);
  const { CardDeatilsData, setCardDeatilsData } =
    useContext(CardDeatilscontext);

  // const { settings } = useSettings();
  const { settings, fetchSettings } = useSettings();

  const { adminLogout, header, userProfileData } = useAdmin();
  const navigate = useNavigate();

  //   const [cachecleared, setCacheCleared] = useState(false);
  const [popup, setPopup] = useState(false);
  //   const [mapRef, setMapRef] = useState(false);
  //   const [config, setConfig] = useState(null);
  //   const [error, setError] = useState("");
  //   const [rideDetails, setRideDetailes] = useState(false);
  //   const [cantTrack, setCantTrack] = useState("");
  //   const [currentLocationMarker, setCurrentLocationMarker] = useState(false);
  //   const [mode, setMode] = useState("");
  const [currentLocation, setCurrentLocation] = useState(null);
  const [placeSelectValue, setPlaceSelectValue] = useState();
  const [showLocationIcon, setShowLocationIcon] = useState(true);
  // for map
  //   const [mapLoaded, setMapLoaded] = useState(false);
  //   const [map, setMap] = useState(false);
  // Input Values
  const [pickUp, setPickUp] = useState(null);
  const [drop, setDrop] = useState(null);
  const [address, setAddress] = useState(null);
  const [popUp, setPop] = useState(null);
  const [loginOn, setLoginOn] = useState(null);
  const [popUpContent, setPopUpContent] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [locationBlock, setLocationBlock] = useState(false);

  const [show, setShow] = useState(false);
  // useEffect(() => {
  //   console.log(drop);
  //   // console.log(JSON.stringify(pickUp));
  //   console.log(JSON.stringify(drop));
  // }, [pickUp, drop]);

  const [enterpickupmanually, setEnterpickupmanually] = useState(false);

  const [googleLoaded, setGoogleLoaded] = useState(false);
  const [bookingType, setBookingType] = useState("INSTANT");
  const [bookingDetails, setBookingDetails] = useState({
    phoneCode: null,
    phoneNumber: null,
    bookingType: bookingType,
    paymentMethod: "CASH",
    category: null,
    date: new Date(new Date().setMinutes(new Date().getMinutes() + 5)), //+70
    manualAssign: false,
    walletBook: false,
    time: new Date(new Date().setMinutes(new Date().getMinutes() + 5)),
  });

  // STATES

  const [selectableCategory, setSelectableCategory] = useState([]);
  const [rideBooking, setRideBooking] = useState(null);
  // const [loading, setLoading] = useState(true);

  // const [stops, setStops] = useState([]);

  // const [guestUser, setGuestUser] = useState(true);
  const [noDrivers, setNoDrivers] = useState(null);
  const [pickUpOutside, setPickUpOutside] = useState(false);
  const [dropOutside, setDropOutside] = useState(false);
  const [categories, setCategories] = useState(null);
  const [categoriesData, setCategoriesData] = useState(null);

  const [numberAcceptable, setNumberAcceptable] = useState(null);

  const [map, setMap] = useState(null);
  // const [pickUp, setPickUp] = useState(null);
  // const [drop, setDrop] = useState(null);
  const [directionData, setDirectionData] = useState(null);

  const [driverMarkers, setDriverMarkers] = useState([]);

  // LOADERS
  const [driverLoading, setDriverLoading] = useState(false);

  const [selectedDistance, setSelectedDistance] = useState(100);
  const [direction, setDirection] = useState(null);
  const [estmationTravelDistance, setEstmationTravelDistance] = useState(0);
  const [estmationTravelTime, setEstmationTravelTime] = useState(0);

  // const { notificationSocket } = useSocket();

  const [user, setUser] = useState(null);
  const [drivers, setDrivers] = useState([]);
  // Login Check
  const [loginToken, setLoginToken] = useState("");
  const [onlyMeNotification, setOnlyMeNotification] = useState([]);
  const [onlyTimePopUp, setOnlyTimePopUp] = useState(false);
  const [oneTimeCurrentLocation, setOneTimeCurrentLocation] = useState(null);
  const [currentPlace_Id, setCurrentPlace_Id] = useState(null);
  const [rideType, setRideType] = useState("ride");
  const [webkey, setwebkey] = useState(false);
  const [categoryHit, setCategoryHit] = useState(false);

  // const colors = [
  //   "#5D8233",
  //   "#3DB2FF",
  //   "#5E454B",
  //   "#7D1935",
  //   "#865439",
  //   "#297F87",
  //   "#DF2E2E",
  // ];
  const rideTypeList = [
    {
      id: 1,
      label: language.NOW,
      value: "INSTANT",
    },
    {
      id: 2,
      label: language.SCHEDULE,
      value: "SCHEDULE",
    },
  ];
  // window.location.reload();
  useEffect(() => {
    window.addEventListener(
      "popstate",
      async (event) => {
        setTimeout(window.history.forward(), 0);
        // console.log(event);
      },
      false
    );
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, document.title, window.location.href);
    });
  }, []);
  // useEffect(() => {
  //   alert(JSON.stringify(drop));
  // }, [drop]);

  useEffect(() => {
    setLoginToken(Cookies.get("CBU"));
    // console.log(rideDeatilsData);
    // rideDeatilsData.pickUp
    //   ? setPickUp(rideDeatilsData.pickUp)
    //   : rideDeatilsData.drop && setDrop(rideDeatilsData.drop);
  }, []);
  const fetchingSettings = async () => await fetchSettings();

  useEffect(() => {
    // console.log("------------");
    // console.log(settings);
    // console.log("------------");
    if (settings !== null && settings?.mapApi?.web) {
      // console.log(JSON.stringify(settings));
      const loader = new Loader({
        apiKey: settings?.mapApi?.web,
        // apiKey: "AIzaSyBbdeSXbRBE0Ts6G8q4XR0uoa8o5KYlnDI",
        version: "weekly",
        libraries: ["places"],
      });
      loader
        .load()
        .then(() => {
          setGoogleLoaded(true);
        })
        .catch((e) => {});
    }
    // console.log("settings");
    // console.log(settings);
  }, [settings?.mapApi?.web]);
  // fetchSettings();
  useEffect(() => {
    //     const fetchConfig = async () => {
    //       try {
    //         const { data } = await axios.get(urls.HOST + urls.REACT_CONFIG);
    //         setConfig(data.data);
    //       } catch (error) {
    //         setError("SOMETHING WENT WRONG");
    //       }
    //       alert(JSON.stringify(config));
    //     };
    //     fetchConfig();
    fetchingSettings();

    userProfile();
    // console.log(user);
    setCardDeatilsData(null);
    // console.log("rideDeatilsData_____Current Location");
    // console.log(rideDeatilsData);
    // console.log(JSON.parse(localStorage.getItem("CurrentLocation")));
    // if (Cookies.get("CBU")) {

    // setOneTimeCurrentLocation(
    //   JSON.parse(localStorage.getItem("CurrentLocation"))
    // );
    // // }
    // setCurrentPlace_Id(JSON.parse(localStorage.getItem("place_Id")));

    // console.log(JSON.parse(localStorage.getItem("place_Id")));
    // console.log(JSON.parse(localStorage.getItem("getRewardsList")));

    // setPopup(false);
    // if (
    //   JSON.parse(localStorage.getItem("CurrentLocation"))
    //   // JSON.parse(localStorage.getItem("place_Id")) !== {}
    // ) {
    //   alert(JSON.stringify(JSON.parse(localStorage.getItem("place_Id"))));
    //   if (JSON.parse(localStorage.getItem("place_Id"))) {
    //     setPopup(false);
    //   }
    // }
  }, []);

  // useEffect(() => {
  //   //   setPopup(false);
  //   //   console.log(popup);

  //   CurrentLocation();

  //   // setTimeout(() => {
  //   if (oneTimeCurrentLocation) {
  //     CurrentLocation();
  //     setPopup(false);
  //     setAddress(true);
  //   }
  //   // }, 350);
  // }, [oneTimeCurrentLocation]);
  // useEffect(() => {
  //   // setTimeout(() => {
  //   if (rideDeatilsData.currentLocation) {
  //     CurrentLocation();
  //     setPopup(false);
  //     setAddress(true);
  //   }
  //   // }, 100);
  // }, [rideDeatilsData.currentLocation]);
  // useEffect(() => {
  //   setTimeout(() => {
  //     if (rideDeatilsData.Location) {
  //       CurrentLocation();
  //       setPopup(false);
  //       setAddress(true);
  //     }
  //   }, 50);
  // }, [rideDeatilsData.Location]);

  const userProfile = async () => {
    try {
      // console.log("header");
      // console.log(header);
      // console.log(userProfileData);

      if (JSON.parse(localStorage.getItem("CBU"))) {
        const { data } = await axios.post(
          A.HOST + A.USER_PROFILE_GET,
          {},
          header
        );

        // alert(JSON.stringify(data.code));
        if (data.code === 200) {
          // alert(JSON.stringify(data));
          setUser(data.data || userProfileData);
          console.log("data.data");
          console.log(data.data);
          const bookingId = data.data.bookingInfo.ongoingBooking;

          if (data?.data?.bookingInfo?.ongoingBooking) {
            // navigate(
            //   NavLinks.RIDE_CONFIRMED +
            //     "/" +
            //     data.data.bookingInfo.ongoingBooking
            // );
            const GetBooking = await axios.post(
              A.HOST + A.GET_ACCEPT_BOOKING,
              { bookingId: bookingId },
              header
            );
            // console.log("GetBooking");
            console.log(GetBooking.data.data.bookingStatus);
            if (GetBooking.data.data.bookingStatus === "ACCEPTED") {
              navigate(NavLinks.RIDE_CONFIRMED + "/" + bookingId);
            } else if (GetBooking.data.data.bookingStatus === "ARRIVED") {
              navigate(NavLinks.ARRIVED + "/" + bookingId);
            } else if (GetBooking.data.data.bookingStatus === "STARTED") {
              navigate(NavLinks.START_RIDE + "/" + bookingId);
            }
          } else if (data?.data?.bookingInfo?.pendingReview) {
            navigate(
              NavLinks.RIDE_REVIEW +
                "/" +
                data.data.bookingInfo.pendingReview || bookingId
            );
          } else if (data?.data?.bookingInfo?.scheduledBooking) {
            // alert("fdfdfd");
            data.data.bookingInfo.scheduledBooking.map((each) => {
              // alert(new Date().getTime());

              if (each.bookingDate > new Date().getTime()) {
                // alert("fdfdf______kjyfhvtbng______-d");

                navigate(NavLinks.SCHEDULE_RIDE_BOOKING + "/" + each.bookingId);
              }
            });
          }
        } else {
          navigate(NavLinks.HOME);
        }

        // console.log("data");
        // console.log(data);
        // if (data.code === 401) {
        //   Cookies.set("CBU", null, 10);
        // }
        // alert("sucess");
      } else {
        navigate(NavLinks.HOME);

        // alert("not get");
        // localStorage.removeItem("CurrentLocation");
        // localStorage.removeItem("place_Id");
        // localStorage.removeItem("SelectedOption");
        // localStorage.setItem("CBU", JSON.stringify({}));
        // localStorage.setItem("CurrentLocation", JSON.stringify({}));
      }
      // ---____----------_---------
      // if (!data.data.userId) {
      // }
      // console.log(data.data);
    } catch (err) {
      // authFailure(err);
      // alert(JSON.stringify(err));
      // alert(err.response.status);

      if (err?.response?.status === 401) {
        // alert(JSON.stringify(err?.response));
        Cookies.remove("CBU");
        Cookies.remove("locu");
        Cookies.remove("lanu");
        // localStorage.setItem("CBU", JSON.stringify({}));
        localStorage.removeItem("CBU");
        // localStorage.removeItem("CurrentLocation");
        // localStorage.removeItem("SelectedOption");
        // localStorage.setItem("CurrentLocation", JSON.stringify({}));
        // window.location.reload();
        // Cookies.set("CBU", null, 10);
      } else {
        navigate(NavLinks.HOME);
      }
      // navigate(NavLinks.REGISTRATION);
    }
  };
  //-----------

  const CurrentLocation = async () => {
    // alert("currentLocation");
    try {
      navigator?.geolocation?.getCurrentPosition(
        (e) => {
          // alert(e);
          setPopup(false);
          setAddress(true);
          if (e) {
            setCurrentLocation({
              lat: e.coords.latitude,
              lng: e.coords.longitude,
            });
            // setOnlyTimePopUp(false);
            // alert(currentLocation + "dsd");
            localStorage.setItem(
              "CurrentLocation",
              JSON.stringify({
                lat: e.coords.latitude,
                lng: e.coords.longitude,
              })
            );
            // setRideDeatilsData({
            //   currentLocation: {
            //     lat: e.coords.latitude,
            //     lng: e.coords.longitude,
            //   },
            // });
          } else {
            // setPopup(false);
            // setPop({ title: "Location Unavaliable", type: "success" });
          }
          // CurrentLocation();
        },
        function (error) {
          setPopup(false);
          setShow(true);
          setModalShow(true);
          setLocationBlock(true);
          // setPopUpContent({
          //   title: "Location Unavaliable",
          //   content: "Please enable the locationfrom device settings",
          // });
          // console.error("Error Code = " + error.code + " - " + error.message);
          // // alert("Location Unavaliable");
          // setPop({ title: "Location Unavaliable", type: "success" });
        }
      );
    } catch (err) {
      alert(err);
    }
    // alert(JSON.stringify(currentLocation));
  };
  useEffect(() => {
    // alert(JSON.stringify(currentLocation));
  }, [currentLocation]);
  // useEffect(() => {
  //   // if (navigator.geolocation) {
  //   //   navigator.permissions
  //   //     .query({ name: "geolocation" })
  //   //     .then(function (result) {
  //   //       if (result.state === "granted") {
  //   //         alert("granted" + result.state);
  //   //         //If granted then you can directly call your function here
  //   //       } else if (result.state === "prompt") {
  //   //         alert("prompt" + result.state);
  //   //       } else if (result.state === "denied") {
  //   //         //If denied then you have to show instructions to enable location
  //   //         alert("denied");
  //   //       }
  //   //       result.onchange = function () {
  //   //         alert(result.state);
  //   //       };
  //   //     });
  //   // } else {
  //   //   alert("Sorry Not available!");
  //   // }
  //   // if (onlyTimePopUp) {
  //   setOnlyTimePopUp(JSON.parse(localStorage.getItem("CurrentLocation")) || 1);
  //   // alert(JSON.parse(localStorage.getItem("CurrentLocation")));
  //   // }
  // }, []);

  const checkAvailableDrivers = async () => {
    // alert("admin" + JSON.stringify(userProfile));
    // alert("Professional_" + JSON.stringify(header));
    setDriverLoading(true);
    setBookingDetails({ ...bookingDetails, category: null });
    try {
      // driverMarkers.length > 0 &&
      //   driverMarkers.map((each) => each.setMap(null));
      // setSelectableCategory([]);
      const { data } = await axios.post(
        A.HOST + A.USER_BOOK_DRIVERS_LIST,
        {
          lat:
            address === true
              ? currentLocation.lat
              : pickUp.results[0].geometry.location.lat,
          lng:
            address === true
              ? currentLocation.lng
              : pickUp.results[0].geometry.location.lng,
          radius: selectedDistance * CONST_MILES_VALUE,
          serviceCategory: categories?.serviceCategory,
          serviceAreaId: categories?.serviceAreaId,
        }
        // header
      );
      // alert("Professional_List" + JSON.stringify(data));
      // setDriverMarkers(
      //   data.map(
      //     (driver) =>
      //       new window.google.maps.Marker({
      //         icon: {
      //           url: carIcon,
      //           scaledSize: new window.google.maps.Size(35, 35),
      //         },
      //         position: {
      //           lat: driver.location.coordinates[1],
      //           lng: driver.location.coordinates[0],
      //         },
      //         map: map,
      //       })
      //   )
      // );

      setDrivers(data);
      let driverAcceptableCategories = [];
      data.forEach((driver) => {
        driver.vehicles.forEach((vehicle) => {
          if (vehicle.defaultVehicle === true) {
            driverAcceptableCategories.push(vehicle.vehicleCategoryId);
            if (
              vehicle.isSubCategoryAvailable === true &&
              vehicle.applySubCategory === true
            ) {
              vehicle.subCategoryIds.map((each) =>
                driverAcceptableCategories.push(each)
              );
            }
          }
        });
      });
      driverAcceptableCategories = [...new Set(driverAcceptableCategories)];

      setSelectableCategory(driverAcceptableCategories);
      setPickUpOutside(false);
      setDropOutside(false);
      setDriverLoading(false);
      if (driverAcceptableCategories.length > 0) setNoDrivers(false);
      else setNoDrivers(true);
      return true;
    } catch (err) {
      // authFailure(err);
      // alert("setNoDrivers" + err);
      // setPop({ title: "No Driver Available", type: "error" });
      setNoDrivers(true);
      setDriverLoading(false);
      return false;
    }
  };

  const fetchCategories = async (inputData) => {
    // await fetchCorporateIds();
    // alert(JSON.stringify(header));
    // alert("step-2");

    setBookingDetails({
      ...bookingDetails,
      category: null,
      manualAssign: false,
    });
    // alert(bookingType);

    // alert("rgasahgzhbsgfh________-");
    // console.log(pickUp);
    // console.log(drop);
    if (pickUp !== null && drop !== null) {
      // alert("rgasahgzhbsgfh");
      const driversAvailable = await checkAvailableDrivers();
      // if (
      //   driversAvailable ||
      //   noDrivers === true
      //   // ||
      //   // bookingDetails.bookingType === U.INSTANT ||
      //   // bookingDetails.bookingType === U.SCHEDULE
      // ) {
      // alert(JSON.stringify("bookingType" + driversAvailable));

      // if (
      //   bookingDetails.bookingType === U.INSTANT ||
      //   bookingDetails.bookingType === U.SCHEDULE
      // ) {
      // alert("step-3");
      let bookingDate = new Date();
      if (bookingDetails.bookingType === U.SCHEDULE) {
        bookingDate = bookingDetails.date;
      }
      let lat = null,
        lng = null;
      // alert("directionData" + JSON.stringify(directionData));
      try {
        navigator.geolocation.getCurrentPosition(function (position) {
          lat = position.coords.latitude;
          lng = position.coords.longitude;
          // alert("Latitude is :" + position.coords.latitude + "" + "Longitude is :" + position.coords.longitude);
        });
        const dataToSend = {
          clientId: settings?.clientId || "",
          userType: user?.userType || "GUESTUSER",
          // userProfile.userType === U.CORPORATE //|| corporate.status === 1
          //   ? U.CORPORATE
          //   : "ALL",
          pickupLat: pickUp.results[0].geometry.location.lat,
          // address === true
          //   ? currentLocation.lat
          //   : pickUp.results[0].geometry.location.lat,
          pickupLng: pickUp.results[0].geometry.location.lng,
          // address === true
          //   ? currentLocation.lng
          //   : pickUp.results[0].geometry.location.lng,
          dropLat: drop.results[0].geometry.location.lat,
          dropLng: drop.results[0].geometry.location.lng,
          lat: lat || settings?.location?.lat,
          lng: lng || settings?.location?.lng,
          // estimationDistance: estmationTravelDistance,
          // estimationTime: estmationTravelTime,
          estimationDistance: inputData.routes[0].legs
            .map((each) => each.distance.value)
            // .map((each) => alert(each.distance.value))

            .reduce((a, b) => a + b),

          estimationTime: inputData.routes[0].legs
            .map((each) => each.duration.value)
            .reduce((a, b) => a + b),
          // estimationPickupDistance: pickupDirectionData?.routes[0]?.legs?.map((each) => each.distance.value).reduce((a, b) => a + b) || 0, // Need to change
          // estimationPickupTime: pickupDirectionData?.routes[0]?.legs?.map((each) => each.duration.value).reduce((a, b) => a + b) || 0, // Need to change
          bookingDate: bookingDate,
          bookingType: bookingType,
          serviceCategoryName: "ride",
          // userProfile.userType === U.CORPORATE // || corporate.status === 1
          //   ? "corporateride"
          //   : "ride",
          // corporateId:
          // admin.userType === U.CORPORATE // || corporate.status === 1
          //   ? corporate.id
          //   : null,
        };
        // alert(JSON.stringify(dataToSend));
        // alert(JSON.stringify(bookingType));
        // alert("step-4");

        const { data } = await axios.post(
          A.HOST + A.USER_BOOK_CATEGORIES_GET,
          dataToSend,
          header
        );

        setCategoriesData(data.data);
        // console.log(data.data);
        // alert(JSON.stringify("data" + data.data));

        // alert("CATEGORYAVAILABLE___" + JSON.stringify(data));
        if (data.status === "CATEGORYAVAILABLE") {
          setCategories(data.data);
        } else if (data.status === "PICKUPLOCATIONOUT") {
          setPickUpOutside(true);
        } else if (data.status === "DROPLOCATIONOUT") {
          setDropOutside(true);
        } else if (data.status === "SERVICENOTAVAILABLE") {
          setNoDrivers(false);
          setPickUpOutside(false);
          setDropOutside(false);
          setNumberAcceptable(true);
          setCategories(null);
        } else setNoDrivers(true);
      } catch (err) {
        // alert("setCategories" + err);
        // console.log(err);
        setPop({ title: err, type: "success" });
      }
    }
    // }
  };

  //console.log(pickUp, drop, "iwrjeonrinbwerjk");

  useEffect(() => {
    // if (markers.pickUp !== null) markers.pickUp.setMap(null);
    // if (markers.drop !== null) markers.drop.setMap(null);
    // if (direction !== null) direction.setMap(null);
    if (pickUp !== null && drop !== null && !categoryHit) {
      //MARKER
      setCategoryHit(true);
      const coordinatesForPath = [
        {
          lat: pickUp.results[0].geometry.location.lat,
          lng: pickUp.results[0].geometry.location.lng,
        },
        {
          lat: drop.results[0].geometry.location.lat,
          lng: drop.results[0].geometry.location.lng,
        },
      ];
      var bounds = new window.google.maps.LatLngBounds();
      coordinatesForPath.forEach((poly) => bounds.extend(poly));
      // map.fitBounds(bounds);

      //CREATING DIRECTIONS
      const directionsService = new window.google.maps.DirectionsService();
      const directionsRenderer = new window.google.maps.DirectionsRenderer();
      var request = {
        origin: {
          lat: pickUp.results[0].geometry.location.lat,
          lng: pickUp.results[0].geometry.location.lng,
        },
        destination: {
          lat: drop.results[0].geometry.location.lat,
          lng: drop.results[0].geometry.location.lng,
        },
        travelMode: "DRIVING",
      };
      // if (stops.filter((stop) => stop.updated === true).length > 0) {
      //   request["waypoints"] = stops
      //     .filter((stop) => stop.updated === true)
      //     .map((stop) => ({
      //       location: new window.google.maps.LatLng(stop.lat, stop.lng),
      //       stopover: true,
      //     }));
      // }
      directionsService.route(request, function (result, status) {
        if (status === "OK") {
          // alert(JSON.stringify(result));

          directionsRenderer.setDirections(result);
          setDirectionData(result);
          setEstmationTravelDistance(
            result.routes[0].legs
              .map((each) => each.distance.value)
              .reduce((a, b) => a + b)
          );
          setEstmationTravelTime(
            result.routes[0].legs
              .map((each) => each.duration.value)
              .reduce((a, b) => a + b)
          );
          fetchCategories(result);
        }
      });
      // alert(JSON.stringify(directionData));
      // directionsRenderer.setMap(map);
      setDirection(directionsRenderer);

      // checkAvailableDrivers();
      // alert(JSON.stringify(drop));
      // alert(JSON.stringify(pickUp));
    }
    if (pickUp === null || drop === null) {
      setCategoryHit(false);
    }
  }, [pickUp, drop, fetchCategories]);

  // useEffect(() => {
  //   // alert("step-1");
  //   // alert(bookingType);
  //   alert(JSON.stringify(estmationTravelDistance));
  //   fetchCategories(directionData);
  // }, [drop, bookingType]);

  useEffect(() => {
    //     const fetchConfig = async () => {
    //       try {
    //         const { data } = await axios.get(urls.HOST + urls.REACT_CONFIG);
    //         setConfig(data.data);
    //       } catch (error) {
    //         setError("SOMETHING WENT WRONG");
    //       }
    //       alert(JSON.stringify(config));
    //     };
    //     fetchConfig();
    userProfile();
    // console.log(user);
    setCardDeatilsData(null);
    setTimeout(async () => {
      setwebkey(true);
    }, 2000);
  }, []);

  return (
    <>
      {/* {settings?.mapApi?.web && webkey ? ( */}
      <div className="overflow-auto h-screen">
        {popUp != null && (
          <PopUp
            unmount={() => setPop(null)}
            title={popUp.title}
            type={popUp.type}
          />
        )}

        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {language.LOCATION_UNAVAILABLE}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <h4>Centered Modal</h4> */}
            <p>{language.ENABLE_DEVICE_LOCATION}</p>
          </Modal.Body>
          <Modal.Footer>
            {/* <Button variant="secondary" onClick={() => setModalShow(false)}>
            Ok
          </Button> */}
            <Button onClick={() => setModalShow(false)}>Ok</Button>
          </Modal.Footer>
        </Modal>

        <main className="zervx_main overflow-auto h-full">
          {loginOn === true ? (
            <Login popUp={"POPUPLOGIN"} />
          ) : (
            <div className="zervx_content  overflow-auto h-full relative">
              <div className=" sticky top-0 z-50 bg-light">
                <NavBar path="home" bookingId={"userProfile"} />
                <Notification />
              </div>
              {rideBooking === null ? (
                <>
                  <section className="location-form-outer">
                    <div className="container">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="bookin-form">
                            <form>
                              {settings?.mapApi?.web && webkey ? (
                                <>
                                  <div className="flex relative items-center font-bold m-2  bg-gray-200">
                                    <label className=" w-[80px] my-auto p-2 uppercase text-[13px]">
                                      {language.FROM}
                                    </label>

                                    {/* {popup === false &&
                                    settings?.mapApi?.web !== null &&
                                    currentLocation ? (
                                      <GooglePlaceComplete
                                        change={(e) => {
                                          setPickUp(e);
                                          // alert(e);
                                        }}
                                        currentLocationValue={
                                          address === true
                                            ? currentLocation ||
                                              oneTimeCurrentLocation ||
                                              rideDeatilsData.currentLocation ||
                                              CardDeatilsData.Location
                                            : null
                                        }
                                        isAutoFetchAddress={true}
                                        addressOneTime={address}
                                        placeholder={language.PICKUP_LOCATION}
                                        className="p-2"
                                      />
                                    ) : (
                                      popup === false &&
                                      settings?.mapApi?.web !== null &&
                                      (locationBlock ||
                                        enterpickupmanually) && (
                                        <GooglePlaceComplete
                                          change={(e) => {
                                            setPickUp(e);
                                            // alert(e);
                                          }}
                                          placeholder={language.PICKUP_LOCATION}
                                          className="p-2 "
                                        />
                                      )
                                    )} */}
                                    {/* )} */}
                                    {popup === false &&
                                      settings?.mapApi?.web !== null && (
                                        <GooglePlaceComplete
                                          pickup
                                          onSetCurrentPick={(value) => {
                                            setPickUp(value);
                                          }}
                                          change={(e) => {
                                            setPickUp(e);
                                          }}
                                          onClearValue={() => {
                                            setPickUp(null);
                                          }}
                                          // currentLocationValue={
                                          //   address === true
                                          //     ? currentLocation ||
                                          //       oneTimeCurrentLocation ||
                                          //       rideDeatilsData?.currentLocation ||
                                          //       CardDeatilsData?.Location
                                          //     : null
                                          // }
                                          // isAutoFetchAddress={true}
                                          // addressOneTime={address}
                                          placeholder={language.PICKUP_LOCATION}
                                          className="p-2"
                                        />
                                      )}
                                  </div>

                                  <div className="flex items-center font-bold m-2 col-span-2 bg-gray-200">
                                    <label className=" w-[80px] my-auto p-2 uppercase text-[13px]">
                                      {language.TO}
                                    </label>

                                    {popup === false &&
                                      settings?.mapApi?.web !== null && (
                                        <GooglePlaceComplete
                                          change={(e) => {
                                            setDrop(e);
                                          }}
                                          onClearValue={() => {
                                            setDrop(null);
                                          }}
                                          bounds={
                                            pickUp
                                              ? {
                                                  lat: pickUp.results[0]
                                                    .geometry.location.lat,
                                                  lng: pickUp.results[0]
                                                    .geometry.location.lng,
                                                }
                                              : false
                                          }
                                          placeholder={language.DROP_LOCATION}
                                          className="w-full"
                                        />
                                      )}
                                  </div>
                                  <div className=" flex items-center font-bold m-2 col-span-2 mt-2 bg-gray-200 pr-2">
                                    <label className="  w-[75px] my-auto p-2 uppercase text-[13px]">
                                      {language.WHEN}
                                    </label>

                                    <DropdownNormal
                                      fields={rideTypeList}
                                      change={(e) => {
                                        setBookingType(e);
                                      }}
                                      defaultValue={bookingType}
                                      className="bg-white"
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className=" Shimmer flex items-center font-bold m-2 col-span-2 ">
                                    <Shimmer width={600} height={40} />
                                  </div>
                                  <div className=" animate-pulse  space-x-4 flex items-center font-bold m-2 col-span-2 ">
                                    {/* <label className="mx-2 w-[60px] h-10 my-auto p-2">
                                    </label> */}
                                    <Shimmer width={600} height={40} />
                                  </div>
                                  <div className=" animate-pulse  space-x-4 flex items-center font-bold m-2 col-span-2 ">
                                    <Shimmer width={600} height={40} />
                                  </div>
                                </>
                              )}
                              {bookingType === "SCHEDULE" && (
                                <div className="flex items-center font-bold m-2 col-span-2 mt-2 bg-gray-200 ">
                                  <label className="m-2  w-[64px] uppercase text-[13px]">
                                    {language.DEPART}
                                  </label>
                                  <div className={`w-full `}>
                                    <CalenderDatePicker
                                      startTime={
                                        new Date(
                                          new Date().setMinutes(
                                            new Date().getMinutes() + 2
                                          )
                                        )
                                      }
                                      afterDays={
                                        settings.dispatchRide
                                          ?.showCalendarDays || 7
                                      }
                                      timeIntervals={
                                        settings.dispatchRide
                                          ?.showCalendarTimeInterval || 10
                                      }
                                      showTime={true}
                                      disableBeforeDays={true}
                                      change={(e) => {
                                        setBookingDetails({
                                          ...bookingDetails,
                                          date: e,
                                          scheduleTime: e.toLocaleString(),
                                        });
                                        // alert(
                                        //   JSON.stringify(
                                        //     new Date(e).toLocaleString()
                                        //   )
                                        // );
                                      }}
                                      defaultValue={bookingDetails.date}
                                    />
                                  </div>
                                </div>
                              )}
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>

                    {drop && (
                      <section className=" overflow-scroll overflow-y-scroll">
                        {pickUp && drop && (
                          <div>
                            <div className="available_rides_title">
                              <div className="flex justify-between px-[29px]">
                                {categoriesData ? (
                                  <>
                                    <h6 className=" uppercase">
                                      {language.AVAILABLE_RIDES}
                                    </h6>

                                    <h6 className="">
                                      {(
                                        estmationTravelDistance /
                                        categoriesData.distanceTypeUnitValue
                                      ).toFixed(2) +
                                        " " +
                                        language[categoriesData.distanceType]}
                                    </h6>
                                    <h6>
                                      {Math.round(estmationTravelTime / 60) +
                                        " " +
                                        language.MINS}
                                    </h6>
                                  </>
                                ) : (
                                  <h6>{""}</h6>
                                )}
                              </div>
                            </div>

                            <div className="mx-4">
                              {categoriesData ? (
                                // categoriesData?.categories?.map(
                                //   (categorie, index) =>
                                //     ((rideType === "ride" &&
                                //       categorie.isPackageSupport === false &&
                                //       bookingType === "INSTANT") ||
                                //       (rideType === "ride" &&
                                //         categorie.isScheduleSupport === true &&
                                //         categorie.isPackageSupport === false &&
                                //         bookingType === "SCHEDULE")) && (
                                //       // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                //       <a
                                //         className=" cursor-pointer"
                                //         key={index + 1}
                                //         onClick={(each) => {
                                //           setRideBooking(categorie);
                                //           setRideDeatilsData({
                                //             rideBooking: categorie,
                                //             pickUp: pickUp,
                                //             drop: drop,
                                //             estmationTravelDistance:
                                //               estmationTravelDistance,
                                //             estmationTravelTime:
                                //               estmationTravelTime,
                                //             booking: bookingDetails,
                                //             categories: categories,
                                //             bookingType: bookingType,
                                //             currentLocation: currentLocation,
                                //             address: address,
                                //             vehicleCategory: categorie,

                                //           });
                                //           localStorage.setItem(
                                //             "SelectedOption",
                                //             JSON.stringify({
                                //               rideBooking: categorie,
                                //               pickUp: pickUp,
                                //               drop: drop,
                                //               estmationTravelDistance:
                                //                 estmationTravelDistance,
                                //               estmationTravelTime:
                                //                 estmationTravelTime,
                                //               booking: bookingDetails,
                                //               categories: categories,
                                //               bookingType: bookingType,
                                //               currentLocation: currentLocation,
                                //               address: address,
                                //               vehicleCategory: categorie,

                                //             })
                                //           );

                                //           navigate(NavLinks.RIDE_BOOKING);
                                //         }}
                                //       >
                                //         <div className="available_rides_box">
                                //           <div className="icon_div">
                                //             <img
                                //               src={categorie.categoryImage}
                                //               alt=""
                                //             />
                                //           </div>
                                //           <div className="content_div">
                                //             <div className="cab-name">
                                //               {categorie.categoryName}
                                //             </div>
                                //             <div className="desc">
                                //               <span>
                                //                 {categoriesData.currencySymbol +
                                //                   " " +
                                //                   categorie.estimationPayableAmount}
                                //               </span>
                                //               {categorie.isShowEstimationfareRange ===
                                //               true ? (
                                //                 <>
                                //                   <span className="mx-2">
                                //                     -
                                //                   </span>
                                //                   <span>
                                //                     {categoriesData.currencySymbol +
                                //                       " " +
                                //                       (
                                //                         categorie.estimationPayableAmount +
                                //                         categorie.showEstimationfareRangeAmount
                                //                       ).toFixed(2)}
                                //                   </span>
                                //                 </>
                                //               ) : (
                                //                 ""
                                //               )}
                                //             </div>
                                //           </div>
                                //           <></>

                                //           <div className="arrow-div">
                                //             <span className="chevron-arrow"></span>
                                //           </div>
                                //         </div>
                                //       </a>
                                //     )

                                // )
                                categoriesData?.categories?.map(
                                  (categorie, index) =>
                                    ((rideType === "ride" &&
                                      categorie.isPackageSupport === false &&
                                      bookingType === "INSTANT") ||
                                      (rideType === "ride" &&
                                        categorie.isScheduleSupport === true &&
                                        categorie.isPackageSupport === false &&
                                        bookingType === "SCHEDULE")) && (
                                      <div
                                        role="button"
                                        className=""
                                        key={index + 1}
                                        onClick={(each) => {
                                          // if (e.categoryID === categories.categoryID) {
                                          setRideBooking(categorie);
                                          // }
                                          // console.log(each);
                                          setRideDeatilsData({
                                            rideBooking: categorie,
                                            pickUp: pickUp,
                                            drop: drop,
                                            estmationTravelDistance:
                                              estmationTravelDistance,
                                            estmationTravelTime:
                                              estmationTravelTime,
                                            // categoriesData:categoriesData,
                                            booking: bookingDetails,
                                            categories: categories,
                                            bookingType: bookingType,
                                            currentLocation: currentLocation,
                                            address: address,
                                            vehicleCategory: categorie,
                                            // vehicleCategory: {
                                            //   categoryImage:
                                            //     categorie.categoryImage,
                                            //   categoryName:
                                            //     categorie.categoryName,
                                            // },
                                          });
                                          localStorage.setItem(
                                            "SelectedOption",
                                            JSON.stringify({
                                              rideBooking: categorie,
                                              pickUp: pickUp,
                                              drop: drop,
                                              estmationTravelDistance:
                                                estmationTravelDistance,
                                              estmationTravelTime:
                                                estmationTravelTime,
                                              // categoriesData:categoriesData,
                                              booking: bookingDetails,
                                              categories: categories,
                                              bookingType: bookingType,
                                              currentLocation: currentLocation,
                                              address: address,
                                              vehicleCategory: categorie,

                                              // vehicleCategory: {
                                              //   categoryImage:
                                              //     categorie.categoryImage,
                                              //   categoryName:
                                              //     categorie.categoryName,
                                              // },
                                            })
                                          );

                                          navigate(NavLinks.RIDE_BOOKING);
                                        }}
                                      >
                                        <div className=" flex justify-between  rounded-xl py-2 px-2 lg:px-4 my-2 border">
                                          <div className="text-center flex items-center justify-evenly lg:gap-5 xl:gap-5 md:gap-8 gap-3">
                                            <img
                                              src={categorie.categoryImage}
                                              alt=""
                                              className="w-14 md:w-20 lg:w-20"
                                            />
                                            <div className="col-span-2 text-start ">
                                              <div className="flex items-center">
                                                <h6 className="mb-0 font-bold text-lg">
                                                  {categorie.categoryName}
                                                </h6>
                                                <FaUser className="ml-2 text-xs text-gray-400" />

                                                <p className=" mb-0 text-xs pl-1">
                                                  {categorie.seatCount}
                                                </p>
                                              </div>
                                              <div>
                                                <div className="text-xs pt-2">
                                                  {categoriesData
                                                    .professionalList[0] ? (
                                                    categoriesData.professionalList.map(
                                                      (driver, index) =>
                                                        categorie.categoryName ===
                                                          driver.serviceType && (
                                                          <>
                                                            {index === 0 && (
                                                              <div className="text-green-400 font-bold text-[10px]">
                                                                {
                                                                  language.DRIVER_IS_HERE
                                                                }
                                                              </div>
                                                            )}
                                                          </>
                                                        )
                                                    )
                                                  ) : (
                                                    <>
                                                      {/* {index === 0 && ( */}
                                                      <div className="text-gray-300 font-bold">
                                                        {
                                                          language.NO_PROFESSIONALS_AVAILABLE
                                                        }
                                                      </div>
                                                      {/* )} */}
                                                    </>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="text-center flex items-center justify-center">
                                            <div>
                                              <div className=" font-bold">
                                                {categoriesData.currencySymbol +
                                                  " " +
                                                  categorie.estimationPayableAmount}
                                              </div>
                                              <div>
                                                {categoriesData
                                                  .professionalList[0] &&
                                                  categoriesData.professionalList.map(
                                                    (driver, index) =>
                                                      categorie.categoryName ===
                                                        driver.serviceType && (
                                                        <>
                                                          {index === 0 && (
                                                            <div className="text-gray-400 font-bold pt-2 text-[10px]">
                                                              {format(
                                                                new Date(
                                                                  new Date().setMinutes(
                                                                    new Date(
                                                                      new Date().getMinutes() +
                                                                        10
                                                                    )
                                                                  )
                                                                ),
                                                                "p"
                                                              )}
                                                            </div>
                                                          )}
                                                        </>
                                                      )
                                                  )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        {/* <div className="grid grid-cols-3">
                                    <div>3</div>
                                    <div>3</div>
                                    <div>3</div>
                                  </div> */}
                                      </div>
                                    )
                                )
                              ) : (
                                <>
                                  <div className="px-2">
                                    <div className=" grid grid-cols-4 gap-2  rounded-xl p-2 my-2 border">
                                      <div className="text-center flex items-center">
                                        <Shimmer
                                          width={40}
                                          height={40}
                                          className="rounded-full "
                                        />
                                      </div>
                                      <div className="col-span-2 text-start ">
                                        <div className="my-2">
                                          <Shimmer
                                            width={200}
                                            height={10}
                                            className="rounded "
                                          />
                                        </div>
                                        <div className="my-2">
                                          <Shimmer
                                            width={200}
                                            height={10}
                                            className="rounded "
                                          />
                                        </div>
                                      </div>
                                      <div className="text-center flex items-center justify-center">
                                        <div>
                                          <div className="my-2">
                                            <Shimmer
                                              width={100}
                                              height={10}
                                              className="rounded "
                                            />
                                          </div>

                                          <div className="my-2">
                                            <Shimmer
                                              width={100}
                                              height={10}
                                              className="rounded "
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="px-2">
                                    <div className=" grid grid-cols-4 gap-2  rounded-xl p-2 my-2 border">
                                      <div className="text-center flex items-center">
                                        <Shimmer
                                          width={40}
                                          height={40}
                                          className="rounded-full "
                                        />
                                      </div>
                                      <div className="col-span-2 text-start ">
                                        <div className="my-2">
                                          <Shimmer
                                            width={200}
                                            height={10}
                                            className="rounded "
                                          />
                                        </div>
                                        <div className="my-2">
                                          <Shimmer
                                            width={200}
                                            height={10}
                                            className="rounded "
                                          />
                                        </div>
                                      </div>
                                      <div className="text-center flex items-center justify-center">
                                        <div>
                                          <div className="my-2">
                                            <Shimmer
                                              width={100}
                                              height={10}
                                              className="rounded "
                                            />
                                          </div>

                                          <div className="my-2">
                                            <Shimmer
                                              width={100}
                                              height={10}
                                              className="rounded "
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="px-2">
                                    <div className=" grid grid-cols-4 gap-2  rounded-xl p-2 my-2 border">
                                      <div className="text-center flex items-center">
                                        <Shimmer
                                          width={40}
                                          height={40}
                                          className="rounded-full "
                                        />
                                      </div>
                                      <div className="col-span-2 text-start ">
                                        <div className="my-2">
                                          <Shimmer
                                            width={200}
                                            height={10}
                                            className="rounded "
                                          />
                                        </div>
                                        <div className="my-2">
                                          <Shimmer
                                            width={200}
                                            height={10}
                                            className="rounded "
                                          />
                                        </div>
                                      </div>
                                      <div className="text-center flex items-center justify-center">
                                        <div>
                                          <div className="my-2">
                                            <Shimmer
                                              width={100}
                                              height={10}
                                              className="rounded "
                                            />
                                          </div>

                                          <div className="my-2">
                                            <Shimmer
                                              width={100}
                                              height={10}
                                              className="rounded "
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="px-2">
                                    <div className=" grid grid-cols-4 gap-2  rounded-xl p-2 my-2 border">
                                      <div className="text-center flex items-center">
                                        <Shimmer
                                          width={40}
                                          height={40}
                                          className="rounded-full "
                                        />
                                      </div>
                                      <div className="col-span-2 text-start ">
                                        <div className="my-2">
                                          <Shimmer
                                            width={200}
                                            height={10}
                                            className="rounded "
                                          />
                                        </div>
                                        <div className="my-2">
                                          <Shimmer
                                            width={200}
                                            height={10}
                                            className="rounded "
                                          />
                                        </div>
                                      </div>
                                      <div className="text-center flex items-center justify-center">
                                        <div>
                                          <div className="my-2">
                                            <Shimmer
                                              width={100}
                                              height={10}
                                              className="rounded "
                                            />
                                          </div>

                                          <div className="my-2">
                                            <Shimmer
                                              width={100}
                                              height={10}
                                              className="rounded "
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="px-2">
                                    <div className=" grid grid-cols-4 gap-2  rounded-xl p-2 my-2 border">
                                      <div className="text-center flex items-center">
                                        <Shimmer
                                          width={40}
                                          height={40}
                                          className="rounded-full "
                                        />
                                      </div>
                                      <div className="col-span-2 text-start ">
                                        <div className="my-2">
                                          <Shimmer
                                            width={200}
                                            height={10}
                                            className="rounded "
                                          />
                                        </div>
                                        <div className="my-2">
                                          <Shimmer
                                            width={200}
                                            height={10}
                                            className="rounded "
                                          />
                                        </div>
                                      </div>
                                      <div className="text-center flex items-center justify-center">
                                        <div>
                                          <div className="my-2">
                                            <Shimmer
                                              width={100}
                                              height={10}
                                              className="rounded "
                                            />
                                          </div>

                                          <div className="my-2">
                                            <Shimmer
                                              width={100}
                                              height={10}
                                              className="rounded "
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        )}
                      </section>
                    )}
                  </section>

                  {/* {enterpickupmanually === true && pickUp === null && (
                  <section>
                    <div className="booking-form-content font-bold pt-1">
                      <i className="fa fa-map-marker" aria-hidden="true"></i>
                      <p>
                        For an accurate pickup - please allow location access
                      </p>

                      <h4>1. Turn on your device location.</h4>
                      <h4>
                        2. Give {settings?.clientCode} access to your browser's
                        location.
                      </h4>
                    </div>
                  </section>
                )} */}
                  <div className=" relative bottom-0 pt-0">
                    {!categoriesData ? (
                      <>
                        {/* <div className="grid grid-cols-2  justify-between">
                          <div className="px-5">
                            <a
                              href={settings?.redirectUrls.userPlayStore}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img src={playImg} alt="" />
                              <p className="text-[10px] text-center">
                                {language.ANDROID_APP_DOWNLOAD}
                              </p>
                            </a>
                          </div>
                          <div className="px-5">
                            <a
                              href={settings?.redirectUrls.userAppstore}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img src={appImg} alt="" />
                              <p className="text-[10px] text-center">
                                {language.IOS_APP_DOWNLOAD}
                              </p>
                            </a>
                          </div>
                        </div> */}
                        {/* {settings?.callCenterPhone ? (
                          <a href={`tel:${settings?.callCenterPhone}`}>
                            <div className=" bg-slate-300 text-center m-4 items-center">
                              <h6 className="py-4 text-black">
                                To immediately book your taxi, call
                                <span
                                  href="#"
                                  
                                  className="px-2 font-semibold text-blue-600"
                                >
                                  {settings?.callCenterPhone}
                                </span>
                              </h6>
                            </div>
                          </a>
                        ) : (
                          <div>
                            <div className="animate-pulse flex space-x-4 bg-slate-300 text-center m-4 items-center">
                              <h6 className="p-4 text-black">
                                <span
                                  href="#"
                                  className="px-2 font-semibold text-blue-600"
                                ></span>
                              </h6>
                            </div>
                          </div>
                        )} */}
                        <div className=" py-4 block col-12 justify-center sticky bottom-0  text-center  w-full">
                          <div className="text-sm text-center col-12 ">
                            {/* {settings?.siteTitle} Ltd. Registered in England and
                          Wales */}
                            {settings?.companyAddress}
                          </div>
                          <div className="text-sm text-center pt-1">
                            {/* Company No. 14412015 */}
                            {settings?.companyRegNumber}
                          </div>
                          <div className=" flex justify-center items-center pt-1">
                            <MdCopyright />
                            <span className="text-sm text-center items-center pl-1 ">
                              {/* {settings?.siteTitle} Ltd,2023 */}
                              {settings?.companyCopyRight}
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="  block col-12 justify-center sticky bottom-0 py-4 text-center  w-full">
                        <div className="text-sm text-center col-12 ">
                          {/* {settings?.siteTitle} Ltd. Registered in England and
                        Wales */}
                          {settings?.companyAddress}
                        </div>
                        <div className="text-sm text-center pt-1">
                          {/* Company No. 14412015 */}
                          {settings?.companyRegNumber}
                        </div>
                        <div className=" flex justify-center items-center pt-1">
                          <MdCopyright />
                          <span className="text-sm text-center items-center pl-1 ">
                            {/* {settings?.siteTitle} Ltd,2023 */}
                            {settings?.companyCopyRight}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* <!-- Main_pop_up --> */}
                  {popup === true ? (
                    <div className="overlay" id="home">
                      <section className="location-permission-outer">
                        <div className="container">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="location-permission-icon flex justify-center">
                                {/* <!-- <i className="fa fa-map-marker" aria-hidden="true"></i> --> */}
                                <svg viewBox="0 0 50 50">
                                  <g>
                                    <path
                                      fill="#000000"
                                      d="M13.5349731,27.9579561 L13.9085123,29.5137416 C8.24967231,30.872411 4.8,33.257165 4.8,35.5999999 C4.8,39.3761094 13.3597262,42.7999999 24,42.7999999 C34.6402738,42.7999999 43.2,39.3761094 43.2,35.5999999 C43.2,33.1096487 39.3116483,30.5926752 33.1033111,29.2918292 L33.4314369,27.7258364 C40.3110441,29.167335 44.8,32.0730863 44.8,35.5999999 C44.8,40.6604464 35.4511162,44.3999999 24,44.3999999 C12.5488838,44.3999999 3.2,40.6604464 3.2,35.5999999 C3.2,32.25646 7.22726543,29.4724166 13.5349731,27.9579561 Z M23.5714286,3.5999999 C26.7857297,3.5999999 29.5178469,4.72498962 31.7678571,6.9749999 C34.0178674,9.22501019 35.1428571,11.9571273 35.1428571,15.1714285 C35.1428571,17.8500136 34.1785817,21.2249776 32.25,25.2964285 C30.3214183,29.3678793 28.3928674,32.7696273 26.4642857,35.5017856 L23.5714286,39.5999999 C22.7142789,38.4214226 21.6428623,36.9080449 20.3571429,35.0598213 C19.0714234,33.2115993 17.3571549,30.1044856 15.2142857,25.7383953 C13.0714176,21.3722999 12,17.8500136 12,15.1714285 C12,11.9571273 13.1249887,9.22501019 15.375,6.9749999 C17.6250103,4.72498962 20.3571274,3.5999999 23.5714286,3.5999999 Z M28.0593871,30.0170829 C31.7930656,23.6164897 33.6571429,18.6633702 33.6571429,15.1714285 C33.6571429,12.3311368 32.6868173,9.94465993 30.7425072,8.00034983 C28.7981971,6.05603973 26.4117203,5.08571419 23.5714286,5.08571419 C20.7311369,5.08571419 18.34466,6.05603973 16.40035,8.00034976 C14.4560406,9.94466119 13.4857143,12.3311387 13.4857143,15.1714285 C13.4857143,18.6633717 15.3497917,23.6164925 19.0837995,30.0176497 C20.7777459,32.9435549 22.2738397,35.3015993 23.5714286,37.091188 C24.8690179,35.3015984 26.3651244,32.9435323 28.0593871,30.0170829 Z M23.5714286,9.82857133 C25.0178363,9.82857133 26.2738912,10.3589056 27.3289214,11.4139357 C28.3839515,12.4689658 28.9142857,13.7250208 28.9142857,15.1714285 C28.9142857,16.6178362 28.3839515,17.8738911 27.3289214,18.9289213 C26.2738912,19.9839514 25.0178363,20.5142856 23.5714286,20.5142856 C22.1250209,20.5142856 20.8689659,19.9839514 19.8139358,18.9289213 C18.7589057,17.8738911 18.2285714,16.6178362 18.2285714,15.1714285 C18.2285714,13.7250208 18.7589057,12.4689658 19.8139358,11.4139357 C20.8689659,10.3589056 22.1250209,9.82857133 23.5714286,9.82857133 Z M23.5714286,19.1482142 C24.695227,19.1482142 25.6435883,18.7660397 26.4048163,18.0048172 C27.1660398,17.2435882 27.5482143,16.2952269 27.5482143,15.1714285 C27.5482143,14.04763 27.1660398,13.0992687 26.4048173,12.3380408 C25.6435883,11.5768172 24.695227,11.1946428 23.5714286,11.1946428 C22.4476301,11.1946428 21.4992688,11.5768172 20.7380409,12.3380398 C19.9768173,13.0992687 19.5946429,14.04763 19.5946429,15.1714285 C19.5946429,16.2952269 19.9768173,17.2435882 20.7380399,18.0048162 C21.4992688,18.7660397 22.4476301,19.1482142 23.5714286,19.1482142 Z"
                                    ></path>
                                  </g>
                                </svg>
                              </div>
                              <div className="location-permission-content">
                                <h4>{language.NEED_YOUR_LOCATION}</h4>
                                <p>
                                  {language.ALLOW_LOCATION_ACCESS}
                                  <span>
                                    {" "}
                                    {language.GET_YOUR_ACCURATE_PICKUP_LOCATION}
                                  </span>
                                </p>
                              </div>
                              <div className="location-permission-btn one  mb-2">
                                {/* <a href="">Continue to next step</a> */}
                                <button
                                  onClick={() => {
                                    CurrentLocation();
                                    setPopup(false);
                                    setAddress(true);
                                  }}
                                  className=" border-0 bg-black w-full rounded-lg text-white p-2 focus:outline-none "
                                >
                                  {language.COUNTINUE_NEXT_STEP}
                                </button>
                              </div>
                              <div className="location-permission-btn mb-2">
                                <button
                                  className=" border-0 bg-transparent focus:outline-none w-full"
                                  href="#"
                                  onClick={() => {
                                    // CurrentLocation();
                                    setPopup(false);
                                    setEnterpickupmanually(true);
                                  }}
                                >
                                  {language.ENTER_YOUR_PICKUP_MANUALLY}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  ) : null}
                </>
              ) : (
                // <RideBooking
                //   rideBooking={rideBooking}
                //   pickUp={pickUp}
                //   drop={drop}
                //   estmationTravelDistance={estmationTravelDistance}
                //   estmationTravelTime={estmationTravelTime}
                //   // categoriesData={categoriesData}
                //   booking={bookingDetails}
                //   categories={categories}
                //   bookingType={bookingType}
                //   currentLocation={currentLocation}
                // />
                <></>
              )}
            </div>
          )}
          {/* Right Side */}
          <div
            className="zervx_rightimg"
            // style={"background-image: url('../assets/images/bg_city.jpg')"}
            // id="bg_image"
          >
            {/* <img src={zervx_Bgimg} alt="" /> */}
            <img
              src={settings?.bookingAppImage}
              alt=""
              className="w-screen h-screen"
            />
            {/* <img src={settings.bookingAppImage} alt="" /> */}

            <div className="global-img-right">
              {/* <h2>
              Ride with <span>Comfort</span>
            </h2>
            <h2>
              Ride with <span>ZervX</span>
            </h2> */}
              <h2>{settings?.bookingAppHomePageMessage}</h2>
            </div>
          </div>
        </main>
      </div>
      {/* // ) : ( // <SmallLoader />
      // )} */}
    </>
  );
}

export default HomePage;
